export const SUPPORT_VENDOR_NAME = ((import.meta.env.VITE_APP_SUPPORT_VENDOR_NAME as string | undefined) ?? "mQorva").trim() || "mQorva";
export const SUPPORT_EMAIL = ((import.meta.env.VITE_APP_SUPPORT_EMAIL as string | undefined) ?? "m1member@mqorva.de").trim();
